import React from 'react'
import styles from '~/styles/page/login/login.module.scss'
import { useTranslation } from 'react-i18next'
import Image from 'next/image'

import { ImagePath } from '~/common/utils/image'
import LoginForm from '~/components/app/form/login/LoginForm'
import LoginFooter from '~/components/atoms/footer/LoginFooter'

const LoginPage = () => {
  const {t} = useTranslation()

  return (
    <>
      <section className={styles.page}>
        <div className={styles.logo}>
          <Image
            src={ImagePath.LOGO}
            alt={'VISLITE'}
            width={271}
            height={56}
          />
        </div>
        <h1 className={styles.title}>{t('login:title')}</h1>
        <LoginForm/>
      </section>
      <LoginFooter/>
    </>
  )
}

export default LoginPage
